export function isCurrentBatchRequest(options: {
  requestGeneration: number;
  currentGeneration: number;
  requestVisibilityGeneration: number;
  currentVisibilityGeneration: number;
  visibilityScoped: boolean;
}): boolean {
  return (
    options.requestGeneration === options.currentGeneration &&
    (!options.visibilityScoped ||
      options.requestVisibilityGeneration ===
        options.currentVisibilityGeneration)
  );
}
